import Modal from '../shared/Modal';

export default function InviteAllModal({ open, onClose, showToast }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Invite All Team Leads"
      footer={
        <>
          <button className="btn" onClick={onClose}>Cancel</button>
          <button className="btn btn-dark" onClick={() => { onClose(); showToast('2 invites sent'); }}>Send 2 Invites</button>
        </>
      }
    >
      <div className="notice-bar">This will send Google login invites to all team leads who haven't been invited yet or are still pending.</div>
      <div style={{ border: '1px solid var(--border)', borderRadius: 'var(--radius)', overflow: 'hidden', marginTop: 4 }}>
        <div style={{ padding: '11px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontFamily: 'var(--font-h)', fontSize: 13, fontWeight: 700, color: 'var(--black)' }}>Sarah Kim</span>
          <span style={{ fontFamily: 'var(--font-b)', fontSize: 12, color: 'var(--muted)' }}>Not Invited · Photo + Video</span>
        </div>
        <div style={{ padding: '11px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontFamily: 'var(--font-h)', fontSize: 13, fontWeight: 700, color: 'var(--black)' }}>Ron Davis</span>
          <span style={{ fontFamily: 'var(--font-b)', fontSize: 12, color: 'var(--muted)' }}>Invite Pending · Security</span>
        </div>
      </div>
    </Modal>
  );
}
